import type { FinishStepProps } from '../types';

import { useFinishInit } from './use-finish-init';
import { useFinishRedirect } from './use-finish-redirect';
import { useFinishStepState } from './use-finish-step-state';
import { useOrganizationVerification } from './use-organization-verification';
import { useWidgetVerification } from './use-widget-verification';

export const useFinishStep = ({ onFinish, getZkProof }: FinishStepProps) => {
    const {
        organizationId,
        sdkOptions,
        isWeb3,
        apiUrl,
        verificationId,
        shortId,
        isCustomPartner,
        isInDashboard,
        isTelegram,
        botName,
    } = useFinishStepState();

    const { verificationData, zkProofProps } = useWidgetVerification({
        isWeb3,
        isCustomPartner,
        apiUrl,
        shortId,
        getZkProof,
    });

    const { actualIcon, actualTitle } = useOrganizationVerification({
        verificationId,
        organizationId,
        isInDashboard,
        isCustomPartner,
        sdkOptions,
    });

    const { timeToRedirect, redirectToLink, startRedirectTimer } = useFinishRedirect(sdkOptions);

    useFinishInit({
        onFinish,
        isCustomPartner,
        isInDashboard,
        sdkOptions,
        startRedirectTimer,
    });

    return {
        isCustomPartner,
        isInDashboard,
        customPartnerProps: {
            verificationData,
            redirectUrl: sdkOptions?.redirectUrl,
        },
        widgetFinishProps: {
            sdkOptions,
            timeToRedirect,
            redirectToLink,
            isTelegram,
            botName,
            ...zkProofProps,
        },
        organizationFinishProps: {
            icon: actualIcon,
            title: actualTitle,
            sdkOptions,
            ...zkProofProps,
        },
    };
};
